import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';
import 'firebase/auth';
import { FirebaseAuthProvider } from '@react-firebase/auth';

import * as ROUTES from './constants/routes';
import * as CONFIG from './constants/firebaseConfig';
import COVER from './assets/cover.jpg';

import Header from './components/Header';
import SignIn from './components/SignIn';
import BibGen from './components/BibGen';
import PrivateRoute from './components/PrivateRoute';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <FirebaseAuthProvider firebase={firebase} {...CONFIG.config}>
      <Router>
        <div>
          <Header />
          <div>
            <div className="cover-image d-none d-xl-block" />
            <img className="img-fluid w-100 d-xl-none" src={COVER} alt="Cover" />
          </div>
          <Switch>
            <Route exact path={ROUTES.SIGN_IN}>
              <SignIn firebase={firebase} />
            </Route>
            <PrivateRoute exact path={ROUTES.LANDING}>
              <BibGen />
            </PrivateRoute>
          </Switch>

          <div className="preload-fonts">
            <div style={{ fontFamily: 'Frutiger-bold' }}>.</div>
            <div style={{ fontFamily: 'Frutiger-roman' }}>.</div>
            <div style={{ fontFamily: 'Gilroy-bold' }}>.</div>
            <div style={{ fontFamily: 'Gilroy' }}>.</div>
          </div>
        </div>
      </Router>
    </FirebaseAuthProvider>
  );
}

export default App;
